import { Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { TranslationService } from '@/app/services/translation.service';
import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';

import { RoutingService } from '@/app/services/routing.service';

interface CompetitionMatchSummary {
  Id: string;
  ImageUrl: string;
  Name: string;
  NameTranslation: Record<string, string> | null;
  TsExternalId: string;
  YoutubeUrl: string;
}

@Component({
  selector: 'app-football-breadcrumbs',
  standalone: true,
  imports: [CommonModule, NzBreadCrumbModule, TranslateModule, RouterModule],
  templateUrl: './football-breadcrumbs.component.html',
})
export class FootballBreadcrumbsComponent {
  private routingService = inject(RoutingService);

  private readonly translationService = inject(TranslationService);

  urlIcon = environment.urlIcon;

  entity = input<'Team' | 'Competition'>('Competition');

  data = input.required<CompetitionMatchSummary>();

  getSoccerIcon() {
    return environment.urlSport + 'football.png';
  }

  getCompetitionLogo() {
    return this.data().ImageUrl;
  }

  getCompetitionName() {
    return this.translationService.getTraduccionName(
      this.data().NameTranslation,
      this.data().Name
    );
  }

  getCompetitionUrl() {
    const competitionId = this.data().Id;

    if (this.entity() === 'Competition') {
      return this.routingService.getTraslateUrlCompetitionDetails(
        {
          es: this.data().NameTranslation?.['es'],
          en: this.data().NameTranslation?.['en'],
        },
        this.data()?.Name ?? '',
        competitionId
      );
    } else {
      return this.routingService.getTraslateUrlTeamDetails(
        {
          es: this.data().NameTranslation?.['es'],
          en: this.data().NameTranslation?.['en'],
        },
        this.data()?.Name ?? '',
        competitionId
      );
    }
  }

  getSoccerCompetitionUrl() {
    return `/${this.translationService.getInitPathFootball()}`;
  }
}
